<template>
  <div class="costContainer" v-loading="loading">
    <div class="headerCon">
      <div class="left"><van-icon name="arrow-left" @click="$router.push('/insuranceHome');" /></div>
      <div class="headerTit">保单信息</div>
      <div class="right">
      </div>
    </div>
    <div class="selectCon">
      <el-select v-model="value" placeholder="请选择" size="medium" @change="chnageChildName">
        <el-option v-for="item in childrenNameList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="costContent">
      <van-cell-group>
        <van-field v-model="name" label="员工姓名" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="relationType" label="关联投保关系" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="childName" label="关联投保姓名" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="gender" label="关联投保性别" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="idType" label="关联投保证件类型" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="idNumber" label="关联投保证件号" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="paymentType" label="付费类型" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="startDate" label="保单生效时间" readonly input-align="right" label-width="160px" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="endDate" label="保单失效时间" readonly input-align="right" label-width="160px" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/insurance.js";
import moment from "moment";
import "moment/locale/zh-cn";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "policy",
  data() {
    return {
      childrenNameList: [],
      value: '',
      carInfo: {
        peopleNum: "",
        marker: ""
      },
      name: "", //姓名
      empno: "", //工号
      isInsured: "", //是否为子女参保
      childName: "", //投保子女姓名
      gender: "", //性别
      idType: "", //证件类型
      idNumber: "", //证件号
      birthDate: "", //出生日期
      isShowBirthdate: false,
      BirthdateTime: "",
      isMarried: "", //是否结婚
      isStudent: "", //投保子女是否在校生
      schoolCity: "", // 学校城市
      schoolName: "", // 学校
      cityCode: "", // 城市编码
      paymentType: '',//付费类型
      startDate: '',//生效时间
      endDate: '',//失效时间
      relationType: '',
      chiledList: [],
      loading: false
    };
  },
  mounted() {
    // this.name =
    //   JSON.parse(localStorage.getItem("store")).userInfo.userid +
    //   "/" +
    //   JSON.parse(localStorage.getItem("store")).userInfo.nickname;
    // let token = window.sessionStorage.hrToken;
    let token = getToken();
    if (token) {
      this.queryEmployeeChild();
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.queryEmployeeChild();
        });
      });
    }

  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;

            this.empno = info.empNo;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    // 获取子女投保信息
    queryEmployeeChild() {
      const json = {
        empno: getToken(),
        page: 1,
        pageSize: 1000,
        filterPolicyStatus: '失效'
      };
      apis.queryByPagePolicyList(json).then(res => {
        if (res.code == "200") {
          console.log("res11", res.data);
          if (getToken()) {
            this.empno = getToken();
          } else {
            this.getHrToken(getToken());
          }
          this.chiledList = res.data;
          this.childrenNameList = res.data.map(item => {
            return {
              label: item.childName,
              value: item.insuredIdNumber,
            };
          });
          this.value = this.childrenNameList.length > 0 ? this.childrenNameList[0].value : '';
          if (this.value) {
            this.querInfo();
          }
        }
      });
    },
    //获取保单信息
    querInfo() {
      // const childNames = this.chiledList.filter(item => item.insuredIdNumber == this.value);
      const json = {
        empno: getToken(),
        keywords: this.value,
        page: 1,
        pageSize: 1000,
        filterPolicyStatus: '失效'
      };
      this.loading = true;
      apis.queryByPagePolicyList(json).then(res => {
        if (res.code == "200") {
          console.log("res11", res.data);

          this.name = res.data.length > 0 ? res.data[0].empno + '/' + res.data[0].employeeName : '', //姓名
            // this.name = res.data[0].name, //姓名
            //   this.empno = res.data[0].empno, //工号
            this.isInsured = res.data.length > 0 && res.data[0].isInsured == true ? '是' : res.data.length > 0 && res.data[0].isInsured == false ? '否' : '', //是否为子女参保
            this.childName = res.data.length > 0 ? res.data[0].childName : '', //投保子女姓名
            this.gender = res.data.length > 0 && res.data[0].insuredGender
              == 1 ? '男' : res.data.length > 0 && res.data[0].insuredGender
                == 2 ? '女' : '', //性别
            this.idType = res.data.length > 0 ? res.data[0].insuredIdType : '', //证件类型
            this.idNumber = res.data.length > 0 ? res.data[0].insuredIdNumber : '', //证件号
            this.birthDate = res.data.length > 0 && res.data[0].birthDate ? moment(res.data[0].birthDate).format(
              "YYYY-MM-DD"
            ) : '', //出生日期
            this.BirthdateTime = res.data.length > 0 && res.data[0].birthDate ? moment(res.data[0].birthDate).format(
              "YYYY-MM-DD"
            ) : '',
            this.isMarried = res.data.length > 0 && res.data[0].isMarried == 1 ? '是' : res.data.length > 0 && res.data[0].isMarried == 0 ? '否' : '', //是否结婚
            this.isStudent = res.data.length > 0 && res.data[0].isStudent == 1 ? '是' : res.data.length > 0 && res.data[0].isStudent == 0 ? '否' : '', //投保子女是否在校生
            this.schoolCity = res.data.length > 0 && res.data[0].schoolCity, // 学校城市
            this.schoolName = res.data.length > 0 && res.data[0].schoolName, // 学校
            this.cityCode = res.data.length > 0 && res.data[0].cityCode;
          this.paymentType = res.data.length > 0 ? res.data[0].paymentType : "";//付费类型
          this.startDate = res.data.length > 0 && res.data[0].startDate ? moment(res.data[0].startDate).format('YYYY-MM-DD') : "";//生效时间
          this.endDate = res.data.length > 0 && res.data[0].endDate ? moment(res.data[0].endDate).format('YYYY-MM-DD') : '';//失效时间
          this.relationType = res.data.length > 0 ? res.data[0].relationType : '';
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    //选择子女投保姓名
    chnageChildName() {
      this.querInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }
}

.costContainer {
  padding-top: 20px;

  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 20px 15px 20px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282B32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    height: 112px;
    background-color: #fff;
    margin-bottom: 20px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;

    .el-select {
      margin-left: 20px;
      width: 180px;
    }

    // .el-input__inner {
    //   height: 70px !important;
    //   line-height: 70px !important;
    // }
  }

  .costContent {
    height: calc(100vh - 222px);
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }
}
</style>
